import { createSlice } from '@reduxjs/toolkit';
import {
  list,
  create,
  update,
  remove,
  setDefault,
  getSingleAddress,
  select,
} from '~store/address/thunks';

const status = {
  list: 'idle',
  create: 'idle',
  update: 'idle',
  remove: 'idle',
  setDefault: 'idle',
};
export const { actions, reducer } = createSlice({
  name: 'address',
  initialState: {
    list: [],
    edit: {},
    default: {},
    selected: {},
    status,
  },
  reducers: {
    edit: (state, action) => {
      state.edit = action.payload;
    },
    selected: (state, action) => {
      state.selected = action.payload;
    },
    setLoading: (state, action) => {
      state.list = state.list.map((item, index) =>
        index == action.payload ? { ...item, loading: true } : item,
      );
    },
    setStatus: (state, { payload: { key, value } }) => {
      state.status[key] = value;
    },
    resetState: (state) => {
      state.list = [];
      state.edit = {};
      state.default = {};
      state.selected = {};
    },
    resetStatus: (state) => {
      state.status = status;
    },
  },
  extraReducers: {
    [list.pending]: (state) => {
      state.status.list = 'pending';
    },
    [list.fulfilled]: (state, { payload }) => {
      const addresses = payload?.data?.[0]?.address ?? [];
      state.list = addresses;
      if (addresses.length > 0) {
        const defaultAddress = addresses.find(({ is_default }) => is_default);
        state.default = defaultAddress || addresses[0];
      } else {
        state.default = {};
      }
      const selectedMatch = state.selected?._id
        ? addresses.find(({ _id }) => _id == state.selected._id)
        : null;

      if (selectedMatch) {
        state.selected = selectedMatch;
      } else if (
        Object.keys(state.selected).length == 0 ||
        state.status.create === 'succeeded'
      ) {
        state.selected = Object.keys(state.default || {}).length
          ? state.default
          : addresses.length > 0
          ? addresses[0]
          : {};
      } else {
        state.selected = addresses[0] || {};
      }
      state.status.list = 'succeeded';
      state.status.create = 'idle';
      state.status.update = 'idle';
      state.status.remove = 'idle';
      state.status.setDefault = 'idle';
    },
    [list.rejected]: (state) => {
      state.status.list = 'rejected';
    },
    [create.pending]: (state) => {
      state.status.create = 'pending';
    },
    [create.fulfilled]: (state, { payload }) => {
      const listNewAddress =
        payload?.data && 'address' in payload.data
          ? payload.data.address
          : null;
      if (listNewAddress) {
        state.list = listNewAddress;
      }
      state.status.list = 'idle';
      state.status.create = 'succeeded';
    },
    [create.rejected]: (state) => {
      state.status.create = 'rejected';
    },
    [update.pending]: (state) => {
      state.status.update = 'pending';
    },
    [update.fulfilled]: (state) => {
      state.status.list = 'idle';
      state.status.update = 'succeeded';
    },
    [update.rejected]: (state) => {
      state.status.update = 'rejected';
    },
    [remove.pending]: (state) => {
      state.status.remove = 'pending';
    },
    [remove.fulfilled]: (state) => {
      state.status.list = 'idle';
      state.status.remove = 'succeeded';
    },
    [setDefault.pending]: (state) => {
      state.status.setDefault = 'pending';
    },
    [setDefault.fulfilled]: (state, action) => {
      const newDefaultId = action.meta.arg?._id;

      state.list = state.list.map((item) => ({
        ...item,
        is_default: item._id === newDefaultId,
        loading: false,
      }));

      const newDefault = state.list.find((item) => item._id === newDefaultId);
      if (newDefault) {
        state.default = newDefault;
        state.selected = newDefault;
      }

      state.status.list = 'idle';
      state.status.setDefault = 'succeeded';
    },
    [setDefault.rejected]: (state) => {
      state.list = state.list.map((item) => ({ ...item, loading: false }));
      state.status.setDefault = 'rejected';
    },
    [getSingleAddress.pending]: (state) => {
      state.status.singleAddress = 'pending';
    },
    [getSingleAddress.fulfilled]: (state, { payload }) => {
      state.status.singleAddress = 'succeeded';
      state.edit = payload;
    },
    [select.pending]: (state) => {
      state.status.update = 'pending';
    },
    [select.fulfilled]: (state) => {
      state.status.list = 'idle';
      state.status.update = 'succeeded';
    },
    [select.rejected]: (state) => {
      state.status.update = 'rejected';
    },
  },
});

export default reducer;
